/**
 * Extends the Icon props but restricts props to "'icon' | 'tooltip' | 'ariaHidden'"
 */

export let HeadingVariant = /*#__PURE__*/function (HeadingVariant) {
  HeadingVariant["Standard"] = "standard";
  HeadingVariant["PrimaryLight"] = "primary-light";
  return HeadingVariant;
}({});
//# sourceMappingURL=types.js.map